<template>
    <b-card no-body header-class="d-flex justify-content-between align-items-start">
        <template v-slot:header>
            <h5>{{ title }}</h5>
            <b-button :id="'add' + title.replaceAll(' ','') + 'Button'" size="sm" variant="outline-secondary" v-on:click="addParty" v-if="!disabled"><i class="fas fa-plus mr-1"></i>Add</b-button>
        </template>
        <b-list-group flush>
            <b-list-group-item v-if="(currentParties == null) || (currentParties.length == 0)">
                The list is currently empty
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-start" v-for="party in currentParties" :key="party.interviewPartyId">
                <div class="p-0 m-0 flex-grow-1">
                    <div>{{ party.title }} {{ party.givenNames }} {{ party.lastName }}</div>
                </div>
                <b-button-group size="sm" v-if="!disabled">
                    <b-button variant="outline-secondary" title="Edit" v-on:click="editParty(party)"><i class="fas fa-edit mr-1"></i>Edit</b-button>
                    <b-button variant="outline-danger" title="Remove" v-on:click="removeParty(party)"><i class="fas fa-times mr-1"></i>Remove</b-button>
                </b-button-group>
            </b-list-group-item>
        </b-list-group>
        <validation-observer v-slot="{ handleSubmit }" slim>
            <b-modal size="lg" centered :title="editDialogTitle" v-model="editPartyDialogShown" v-on:ok.prevent="handleSubmit(createOrUpdateParty)">
                <b-form-row>
                    <validation-provider rules="required" name="Title" v-slot="{ errors }" slim>
                        <b-form-group label="Title"
                                      label-for="title"
                                      class="col-md-2">
                            <b-form-input name="title"
                                          autofocus
                                          v-model="currentParty.title"
                                          :state="errors[0] ? false : null">
                            </b-form-input>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider rules="required" name="Given Name/s" v-slot="{ errors }" slim>
                        <b-form-group label="Given Name/s"
                                      label-for="givenNames"
                                      class="col-md-5">
                            <b-form-input name="givenNames"
                                          v-model="currentParty.givenNames"
                                          :state="errors[0] ? false : null">
                            </b-form-input>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider rules="required" name="Last Name" v-slot="{ errors }" slim>
                        <b-form-group label="Last Name"
                                      label-for="lastName"
                                      class="col-md-5">
                            <b-form-input name="lastName"
                                          v-model="currentParty.lastName"
                                          :state="errors[0] ? false : null">
                            </b-form-input>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                </b-form-row>
            </b-modal>
        </validation-observer>
    </b-card>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';

    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { extend, localize } from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    localize('en', en);

    Vue.use(BootstrapVue);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);
    
    export default {
        name: 'InterviewParties',
        model: {
            event: 'change',
            prop: 'parties'
        },
        props: {
            title: {
                type: String,
                required: true
            },
            editDialogTitle: {
                type: String,
                default: 'Party Details'
            },
            parties: {
                type: Array,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                currentParties: this.parties,
                currentParty: null,
                editPartyDialogShown: false
            };
        },
        watch: {
            parties: function () {
                this.currentParties = this.parties;
            }
        },
        methods: {
            addParty: function () {
                this.currentParty = { title: null, lastName: null, givenNames: null, index: null };
                this.editPartyDialogShown = true;
            },
            editParty: function (party) {
                this.currentParty = { title: party.title, lastName: party.lastName, givenNames: party.givenNames, index: this.currentParties.indexOf(party) };
                this.editPartyDialogShown = true;
            },
            createOrUpdateParty: function () {
                if (this.currentParty.index == null) {
                    delete this.currentParty.index;
                    if (this.currentParties == null) this.currentParties = [];
                    this.currentParties.push(this.currentParty);
                } else {
                    this.currentParties[this.currentParty.index].title = this.currentParty.title;
                    this.currentParties[this.currentParty.index].lastName = this.currentParty.lastName;
                    this.currentParties[this.currentParty.index].givenNames = this.currentParty.givenNames;
                }
                this.editPartyDialogShown = false;
                this.$emit('change', this.currentParties);
            },
            removeParty: function (party) {
                var index = this.currentParties.indexOf(party)
                this.currentParties.splice(index, 1);
                this.$emit('change', this.currentParties);
            }
        }
    }
</script>